module.exports = __webpack_public_path__ + "static/img/img_4.63e52a55.jpg";